<template>
  <div
    v-if="webform"
    class="max-w-prose"
    :class="{
      'bk-paragraph-region-affected': options.isHidden,
    }"
  >
    <Webform :webform="webform" />
  </div>
</template>

<script lang="ts" setup>
import type { ParagraphWebformFragment } from '#graphql-operations'

await initFormKit()

const { options } = defineBlokkli({
  bundle: 'webform',
  globalOptions: ['isHidden'],
  chunkName: 'rare',
})

const props = defineProps<{
  form: ParagraphWebformFragment['form']
}>()

const id = computed(() => {
  return props?.form?.id
})

const { data: webform } = await useAsyncData(() => {
  return useGraphqlQuery('webform', { id: id.value || '' }).then(
    (v) => v.data.webform,
  )
})
</script>
